import React, { useEffect } from 'react';
import '../styles/LocationMap.scss';
import map from '../assets/Lonavalley-map.png';


const pins = [
    { name: 'Wet & Joy Waterpark', dist: '15 min' },
    { name: 'Old Mumbai Pune Highway', dist: '15 min' },
    { name: 'Shirota Dam', dist: '2 min' },
    { name: 'Kamshet Paragliding', dist: '15 min' },
    { name: 'Karla Caves', dist: '25 min' }, 
];


export default function LocationMap() {
    useEffect(() => {
        // small scroll zoom highlight effect
        const el = document.querySelector('.map-illustration');
        if (!el) return;
        const onScroll = () => {
            const rect = el.getBoundingClientRect();
            const winH = window.innerHeight;
            const progress = Math.max(0, Math.min(1, 1 - (rect.top / winH)));
            el.style.transform = `scale(${1 + progress * 0.06})`;
        };
        window.addEventListener('scroll', onScroll);
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    return (
        <section id="location" className="location">
            <div className="container">
                <h2>Location & Advantages</h2>
                <p className="lead">Strategically placed near Lonavala with easy connectivity to Pune and Mumbai.</p>


                <div className="map-wrap">
                    <div className="map-illustration" aria-hidden>
                        <img src={map} alt="Map illustration showing project location and nearby attractions" />
                    </div>


                    <aside className="nearby">
                        {pins.map((p, i) => (
                            <div key={i} className="nearby-card">
                                <strong>{p.name}</strong>
                                <span>{p.dist}</span>
                            </div>
                        ))}
                    </aside>
                </div>
            </div>
        </section>
    );
}